<template>
  <div>
    <breadcrumb/>
    <PostList category="BBPP Noticias – Origen al día" />
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>